// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdminDashboardController from "./admin_dashboard_controller"
application.register("admin-dashboard", AdminDashboardController)

import AgendaHeaderController from "./agenda_header_controller"
application.register("agenda-header", AgendaHeaderController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import BadgeLoginController from "./badge_login_controller"
application.register("badge-login", BadgeLoginController)

import BarcodeScannerController from "./barcode_scanner_controller"
application.register("barcode-scanner", BarcodeScannerController)

import BookablePaginationController from "./bookable_pagination_controller"
application.register("bookable-pagination", BookablePaginationController)

import BookingSlotSelectorController from "./booking_slot_selector_controller"
application.register("booking-slot-selector", BookingSlotSelectorController)

import BusinessHoursOverrideFormController from "./business_hours_override_form_controller"
application.register("business-hours-override-form", BusinessHoursOverrideFormController)

import ClientAlertBannerController from "./client_alert_banner_controller"
application.register("client-alert-banner", ClientAlertBannerController)

import ClientAlertLoaderController from "./client_alert_loader_controller"
application.register("client-alert-loader", ClientAlertLoaderController)

import ClientComboboxController from "./client_combobox_controller"
application.register("client-combobox", ClientComboboxController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ComboboxController from "./combobox_controller"
application.register("combobox", ComboboxController)

import DashboardChartController from "./dashboard_chart_controller"
application.register("dashboard-chart", DashboardChartController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import DualSignatureController from "./dual_signature_controller"
application.register("dual-signature", DualSignatureController)

import DuplicateSelectionController from "./duplicate_selection_controller"
application.register("duplicate-selection", DuplicateSelectionController)

import EidImportController from "./eid_import_controller"
application.register("eid-import", EidImportController)

import EnrollmentController from "./enrollment_controller"
application.register("enrollment", EnrollmentController)

import FilesUploadController from "./files_upload_controller"
application.register("files-upload", FilesUploadController)

import GiftCardValidityController from "./gift_card_validity_controller"
application.register("gift-card-validity", GiftCardValidityController)

import InlineCalendarController from "./inline_calendar_controller"
application.register("inline-calendar", InlineCalendarController)

import ItemInfoController from "./item_info_controller"
application.register("item-info", ItemInfoController)

import MinimumDelayWarningController from "./minimum_delay_warning_controller"
application.register("minimum-delay-warning", MinimumDelayWarningController)

import MultiSelectController from "./multi_select_controller"
application.register("multi-select", MultiSelectController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import NewSettingController from "./new_setting_controller"
application.register("new-setting", NewSettingController)

import NotificationController from "./notification_controller"
application.register("notification", NotificationController)

import OperationalStatusController from "./operational_status_controller"
application.register("operational-status", OperationalStatusController)

import PaymentModalController from "./payment_modal_controller"
application.register("payment-modal", PaymentModalController)

import PaymentOptionController from "./payment_option_controller"
application.register("payment-option", PaymentOptionController)

import PhototypeQuestionnaireController from "./phototype_questionnaire_controller"
application.register("phototype-questionnaire", PhototypeQuestionnaireController)

import PrintPdfController from "./print_pdf_controller"
application.register("print-pdf", PrintPdfController)

import ProductVatController from "./product_vat_controller"
application.register("product-vat", ProductVatController)

import QuantityEditorController from "./quantity_editor_controller"
application.register("quantity-editor", QuantityEditorController)

import QuickAmountController from "./quick_amount_controller"
application.register("quick-amount", QuickAmountController)

import ScheduleController from "./schedule_controller"
application.register("schedule", ScheduleController)

import ScheduleDragDropController from "./schedule_drag_drop_controller"
application.register("schedule-drag-drop", ScheduleDragDropController)

import ScheduleFormController from "./schedule_form_controller"
application.register("schedule-form", ScheduleFormController)

import ScheduleNavigationController from "./schedule_navigation_controller"
application.register("schedule-navigation", ScheduleNavigationController)

import SalesStatsChartController from "./sales_stats_chart_controller"
application.register("sales-stats-chart", SalesStatsChartController)

import SalesStatsPeriodsController from "./sales_stats_periods_controller"
application.register("sales-stats-periods", SalesStatsPeriodsController)

import EmployeeSelectController from "./employee_select_controller"
application.register("employee-select", EmployeeSelectController)

import SelectController from "./select_controller"
application.register("select", SelectController)

import SelectVisibilityController from "./select_visibility_controller"
application.register("select-visibility", SelectVisibilityController)

import SessionTimeoutController from "./session_timeout_controller"
application.register("session-timeout", SessionTimeoutController)

import ShiftIndicatorController from "./shift_indicator_controller"
application.register("shift-indicator", ShiftIndicatorController)

import SignaturePadController from "./signature_pad_controller"
application.register("signature-pad", SignaturePadController)

import SubscriptionPlanFormController from "./subscription_plan_form_controller"
application.register("subscription-plan-form", SubscriptionPlanFormController)

import SunbedDurationController from "./sunbed_duration_controller"
application.register("sunbed-duration", SunbedDurationController)

import SunbedPricesController from "./sunbed_prices_controller"
application.register("sunbed-prices", SunbedPricesController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TagsSSelectController from "./tags_s_select_controller"
application.register("tags-s-select", TagsSSelectController)

import TagsSelectController from "./tags_select_controller"
application.register("tags-select", TagsSelectController)

import TerminalSelectionController from "./terminal_selection_controller"
application.register("terminal-selection", TerminalSelectionController)

import TerminalStatusSubscriptionController from "./terminal_status_subscription_controller"
application.register("terminal-status-subscription", TerminalStatusSubscriptionController)

import TimeBlocksController from "./time_blocks_controller"
application.register("time-blocks", TimeBlocksController)

import TimeslotReservationController from "./timeslot_reservation_controller"
application.register("timeslot-reservation", TimeslotReservationController)

import TimeslotReservationModalController from "./timeslot_reservation_modal_controller"
application.register("timeslot-reservation-modal", TimeslotReservationModalController)

import TiptapEditorController from "./tiptap_editor_controller"
application.register("tiptap-editor", TiptapEditorController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import TreatmentDurationController from "./treatment_duration_controller"
application.register("treatment-duration", TreatmentDurationController)

import UppyController from "./uppy_controller"
application.register("uppy", UppyController)

import UserScheduleController from "./user_schedule_controller"
application.register("user-schedule", UserScheduleController)

import VariableInserterController from "./variable_inserter_controller"
application.register("variable-inserter", VariableInserterController)

import WorkingHoursWarningController from "./working_hours_warning_controller"
application.register("working-hours-warning", WorkingHoursWarningController)
